const OTP_ROLES = ['USER', 'ZONE HEAD'];

export const usesFixedOtp = (roles) => {
  const list = Array.isArray(roles) ? roles.filter(Boolean) : [];
  return list.length > 0 && list.every((role) => OTP_ROLES.includes(role));
};

const STORAGE_KEY = 'user_role_otps';

export const readStoredUserOtps = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
};

export const rememberUserOtp = (userId, otp) => {
  const current = readStoredUserOtps();
  current[String(userId)] = otp;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
};

export const createUserOtp = async (phone) => {
  const mobile = String(phone || '').replace(/\D/g, '');
  const encoded = new TextEncoder().encode(mobile);
  const digest = await crypto.subtle.digest('SHA-256', encoded);
  const hash = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
  const otp = String((parseInt(hash.slice(0, 8), 16) % 900000) + 100000);
  return { otp, hash };
};
